import React from 'react';
import {
  AppBar,
  Toolbar,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import {
  makeStyles,
  createStyles,
} from '@material-ui/styles';

import PagesMainBarContentSm from './PagesMainBarContentSm';
import PagesMainBarContentLg from './PagesMainBarContentLg';
import { ExtendedTheme } from '../../theme';

const useStyles = makeStyles(({ palette, container }: ExtendedTheme) => createStyles({
  root: {
    backgroundColor: palette.publicNavBar.background,
    boxShadow: 'none',
  },

  toolbar: {
    margin: '0 auto',
    maxWidth: container,
    width: '100%',
    justifyContent: 'center',
    // boxShadow: '1px 1px 5px #ccc',
    padding: 0,
  },
}), { name: 'PagesMainBar' });

const PagesMainBar = () => {
  const classes = useStyles();

  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar className={classes.toolbar}>
        {compact ? <PagesMainBarContentSm /> : <PagesMainBarContentLg />}
      </Toolbar>
    </AppBar>
  );
};

export default PagesMainBar;
